module.exports = __webpack_public_path__ + "static/media/Custom_Dev.44576420.png";